import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'
import { UserProfile, AuthUser } from './userSlice.types'

interface UserState {
  authStateKnown: boolean
  authUser: AuthUser | null
  userProfile: UserProfile | null
  invitations: Array<{ id: string }>
}

const initialState: UserState = {
  authStateKnown: false,
  authUser: null,
  userProfile: null,
  invitations: [],
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<AuthUser | null>) => {
      state.authUser = action.payload
      state.authStateKnown = true
    },
    setUserProfile: (state, action: PayloadAction<UserProfile | null>) => {
      state.userProfile = action.payload
    },
    setInvitations: (state, action: PayloadAction<Array<{ id: string }>>) => {
      state.invitations = action.payload
    },
  },
})

export const { setAuth, setUserProfile, setInvitations } = userSlice.actions

export const selectUserProfile = (state: RootState) => state.user.userProfile
export const selectUserId = (state: RootState) => state.user.authUser?.id
export const selectAuthUser = (state: RootState) => state.user.authUser
export const selectAuthStateKnown = (state: RootState) =>
  state.user.authStateKnown

export const selectInvitations = (state: RootState) => state.user.invitations

export const selectIsAuthenticated = (state: RootState) => {
  return !!selectAuthUser(state) && !!selectAuthStateKnown(state)
}

export default userSlice.reducer
